import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { NamedRegion } from "./NamedRegion";
import { Qualifier } from "../../internal/qualifier/Qualifier";
/**
 * @memberOf Qualifiers.Region
 */

var CustomRegion = /*#__PURE__*/function (_NamedRegion) {
  _inherits(CustomRegion, _NamedRegion);

  var _super = _createSuper(CustomRegion);

  function CustomRegion() {
    _classCallCheck(this, CustomRegion);

    return _super.call(this, 'named');
  }
  /**
   * @description The x position in pixels.
   * @param {number} x
   */


  _createClass(CustomRegion, [{
    key: "x",
    value: function x(_x) {
      this.addQualifier(new Qualifier('x', _x));
      return this;
    }
    /**
     * @description The y position in pixels.
     * @param {number} y
     */

  }, {
    key: "y",
    value: function y(_y) {
      this.addQualifier(new Qualifier('y', _y));
      return this;
    }
    /**
     * @description The width of the region in pixels.
     * @param {number} width
     */

  }, {
    key: "width",
    value: function width(_width) {
      this.addQualifier(new Qualifier('w', _width));
      return this;
    }
    /**
     * @description The height of the region in pixels.
     * @param {number} height
     */

  }, {
    key: "height",
    value: function height(_height) {
      this.addQualifier(new Qualifier('h', _height));
      return this;
    }
  }]);

  return CustomRegion;
}(NamedRegion);

export { CustomRegion };